import { type PropsWithChildren, forwardRef } from 'react';

import styles from './Switcher.css';

export const Switcher = forwardRef<HTMLDivElement, PropsWithChildren>(function Switcher({ children }, ref) {
  return (
    <div className={styles['switcher']} ref={ref}>
      {children}
    </div>
  );
});
